export enum Routes {
  RevenueManager = '/pages/revenue-manager',
  Settings = '/pages/settings',
  BookingOverview = '/pages/booking-overview',
  AutoConfirm = '/pages/pricing-rules',
  PageNotFound = '/page-not-found',
  AdminSettings = '/pages/admin-settings',
}

export enum RolesEnum {
  ViewerRole = 'viewer',
  EditorRole = 'editor',
  AdminRole = 'admin',
  SuperAdminRole = 'super_admin',
}
